import { defineComponent } from "../../../common/runtime/defineComponent.svelte";

defineComponent({
  tag: "oc-async-fragment-v1",
  extendOptions: { useShadow: false },
  props: {
    url: {},
    base64Url: {},
    inactive: { type: "Boolean" },
    allowedStatusCodes: { type: "Array", attribute: "allowed-status-codes" },
    discardOnInactive: { type: "Boolean", attribute: "discard-on-inactive" },
    replacementTarget: { type: "String", attribute: "replacement-target" },
  },
  component: () => import("./AsyncFragmentV1.svelte"),
});
